'use strict';

/**
 * A service providing authentication features.
 */
customerZone.service('AuthenticationService', ['UnleashedClient', 'Session',  '$log', '$q',
    function(api, Session, $log, $q){
        var self = this;

        /**
         * Log in a user using username and password.
         * If the login is successful, populate the session with the user details.
         * @returns a promise resolving to the string 'OK' on success, otherwise a specific error message.
         */
        self.login = function(username, password){
            return api.getToken(username, password)
                .then(function(tokenResponse){
                    return startSession(tokenResponse.token, tokenResponse.refreshToken, username);
                });
        };

        /**
         * Starts a session based on a login token.
         * @param token the token used to identify with
         * @param refreshToken the token used to refresh with when this one expires (if any)
         * @param username the username used to create the token (if any)
         * @return a Promise that will resolve if successful.
         */
        var startSession = function(token, refreshToken, username){
            // at this point, the session is not active yet, so we need to explicitly authenticate
            // every request.
            var authApi = api.authenticatedWith(token);
            return authApi.getCustomer()
                .then(function(profile){
                    return authApi.getSubscribersForCustomer()
                        .then(function(subscribers){
                            Session.create(username || profile.id, token, refreshToken);
                            Session.profile(profile);
                            Session.subscribers(subscribers, username);
                            if (profile.passwordLeaked) Session.passwordLeaked(true);
                            return 'OK';
                        });
                });
        };

        /**
         * Log in as a user using a token received from an external source.
         */
        self.impersonate = function(token){
            return startSession(token)
                .then(function(result){
                    Session.impersonating(true);
                    return result;
                });
        };

        /**
         * Request a new token with the current user's refresh token.
         * @returns a promise resolving if everything went fine, rejecting if the refresh did not succeed
         */
        self.refresh = function(){
            if (!Session.refreshToken) return $q.reject('no refresh token available');
            return api.refreshToken(Session.username, Session.refreshToken)
                .then(function(tokenResponse){
                    Session.updateToken(tokenResponse.token, tokenResponse.refreshToken);
                    Session.refresh();
                    return 'OK';
                }, function(reject){
                    throw reject.message;
                });
        };

        Session.setRefreshHandler(function(){
            $log.debug('Refreshing session');

            var promises = [];

            promises.push(api.getCustomer()
                .then(
                    function(profile){
                        Session.profile(profile);
                    },
                    function(error){
                        $log.error('Failed to refresh customer profile: ', error);
                    }));
            promises.push(api.getSubscribersForCustomer()
                .then(
                    function(subscribers){
                        Session.subscribers(subscribers);
                    },
                    function(error){
                        $log.error('Failed to refresh customer subscription: ', error);
                    }));

            return $q.all(promises);
        });

    }]);
